function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "Rectangle_106730",
  "data-name": "Rectangle 106730",
  width: 17.164,
  height: 17.164
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_20233",
  "data-name": "Group 20233",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_24978",
  "data-name": "Path 24978",
  d: "M8.582,0a8.582,8.582,0,1,0,8.582,8.582A8.582,8.582,0,0,0,8.582,0M3.457,7.514a1.908,1.908,0,0,1,3.815,0,.657.657,0,0,1-.656.656h0a.658.658,0,0,1-.656-.656.6.6,0,0,0-1.192,0,.656.656,0,0,1-1.312,0m9.377,3.7c-.011.012-.022.023-.033.033a5.965,5.965,0,0,1-4.2,1.745H8.567a5.961,5.961,0,0,1-4.2-1.748.656.656,0,0,1,.923-.93,4.659,4.659,0,0,0,6.583,0h0a.656.656,0,1,1,.959.9m.218-3.051h0a.658.658,0,0,1-.656-.656.6.6,0,1,0-1.192,0,.656.656,0,0,1-1.312,0,1.908,1.908,0,0,1,3.815,0,.657.657,0,0,1-.656.656",
  transform: "translate(0 0.001)"
}));

var SvgEmoji = function SvgEmoji(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17.164,
    height: 17.164,
    viewBox: "0 0 17.164 17.164",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmoji, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Emoji.2dd9a26c.svg";
export { ForwardRef as ReactComponent };